(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7JAKl", function(module, exports) {

$parcel$export(module.exports, "OUTPUT_FORMATS", () => $5a193d7426028a6c$export$314b93693e42ef22);
$parcel$export(module.exports, "canEncode", () => $5a193d7426028a6c$export$32d8af07dd2de268);
$parcel$export(module.exports, "decode", () => $5a193d7426028a6c$export$2f872c0f2117be69);
$parcel$export(module.exports, "hasAlpha", () => $5a193d7426028a6c$export$7c6623716c246f1);
$parcel$export(module.exports, "sizeOf", () => $5a193d7426028a6c$export$30043de3fae42dd1);
$parcel$export(module.exports, "fitWithin", () => $5a193d7426028a6c$export$2cf9958cd81e83ad);
$parcel$export(module.exports, "draw", () => $5a193d7426028a6c$export$e529deb2bfd496dc);
$parcel$export(module.exports, "encode", () => $5a193d7426028a6c$export$c564cdbbe6da493);
$parcel$export(module.exports, "renameExtension", () => $5a193d7426028a6c$export$a7b7f54182084c78);
$parcel$export(module.exports, "saveBlob", () => $5a193d7426028a6c$export$9016c9576545678);
$parcel$export(module.exports, "formatBytes", () => $5a193d7426028a6c$export$e1a3971de07c83b5);
// Decoding, encoding and the small conveniences that both browser tools need.
//
// Everything here works on the bytes the visitor picked and never touches the
// network. That is the whole promise of /tools, so nothing in this file may
// grow a fetch of the image itself.
// Feature-detected once per page rather than per file. A browser that cannot
// encode a format answers toBlob with a PNG instead of failing, so asking for
// AVIF and trusting the result would silently hand out a mislabelled file.
const $5a193d7426028a6c$var$encoderSupport = new Map();
const $5a193d7426028a6c$export$314b93693e42ef22 = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        lossy: false,
        note: 'Lossless, keeps transparency'
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        lossy: true,
        note: 'Small, no transparency'
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        lossy: true,
        note: 'Small and keeps transparency'
    },
    {
        mime: 'image/avif',
        label: 'AVIF',
        extension: 'avif',
        lossy: true,
        note: 'Smallest, not encodable everywhere'
    }
];
function $5a193d7426028a6c$export$32d8af07dd2de268(mime) {
    if (mime === 'image/png') return Promise.resolve(true);
    if (!$5a193d7426028a6c$var$encoderSupport.has(mime)) $5a193d7426028a6c$var$encoderSupport.set(mime, new Promise((resolve)=>{
        const probe = document.createElement('canvas');
        probe.width = 1;
        probe.height = 1;
        try {
            probe.toBlob((blob)=>resolve(!!blob && blob.type === mime), mime, 0.9);
        } catch (err) {
            resolve(false);
        }
    }));
    return $5a193d7426028a6c$var$encoderSupport.get(mime);
}
async function $5a193d7426028a6c$export$2f872c0f2117be69(file) {
    if (typeof createImageBitmap === 'function') try {
        return await createImageBitmap(file, {
            imageOrientation: 'from-image'
        });
    } catch (err) {
    // Falls through. Either the format is one this browser cannot
    // decode, which the fallback will report the same way, or the
    // options argument is unsupported, which the fallback handles.
    }
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error('This browser cannot decode that image'));
            img.src = url;
        });
    } finally{
        // Revoking immediately is safe: a loaded <img> keeps its own decoded
        // copy, and a failed one has nothing left to read.
        URL.revokeObjectURL(url);
    }
}
function $5a193d7426028a6c$export$7c6623716c246f1(image) {
    const PROBE = 128;
    const { width: width, height: height } = $5a193d7426028a6c$export$30043de3fae42dd1(image);
    const w = Math.max(1, Math.min(PROBE, width));
    const h = Math.max(1, Math.min(PROBE, height));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    for(let i = 3; i < data.length; i += 4){
        if (data[i] < 255) return true;
    }
    return false;
}
function $5a193d7426028a6c$export$30043de3fae42dd1(image) {
    return {
        width: image.width || image.naturalWidth,
        height: image.height || image.naturalHeight
    };
}
function $5a193d7426028a6c$export$2cf9958cd81e83ad(width, height, maxWidth, maxHeight) {
    const scale = Math.min(maxWidth ? maxWidth / width : 1, maxHeight ? maxHeight / height : 1, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $5a193d7426028a6c$export$e529deb2bfd496dc(image, width, height, background) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function $5a193d7426028a6c$export$c564cdbbe6da493(canvas, mime, quality) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error(`Could not encode as ${mime}`)), mime, // Undefined rather than a number for PNG: passing a quality to a
        // lossless encoder is meaningless, and some browsers take it as a
        // hint to switch to a lossy one.
        quality);
    });
}
function $5a193d7426028a6c$export$a7b7f54182084c78(filename, extension) {
    const stem = filename.replace(/\.[^.]+$/, '') || 'image';
    return `${stem}.${extension}`;
}
function $5a193d7426028a6c$export$9016c9576545678(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // A revoke on the next tick rather than straight away. Chrome starts the
    // download asynchronously and reads the URL after the click returns.
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $5a193d7426028a6c$export$e1a3971de07c83b5(bytes) {
    if (!bytes) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, power);
    return `${value >= 100 || power === 0 ? Math.round(value) : value.toFixed(1)} ${units[power]}`;
}

});

parcelRegister("65gAn", function(module, exports) {

$parcel$export(module.exports, "wirePicker", () => $46e0134a81c5c949$export$a7ad1357dc53be0f);
$parcel$export(module.exports, "blockStrayDrops", () => $46e0134a81c5c949$export$9587a56f399e19d6);
$parcel$export(module.exports, "initColourPicker", () => $46e0134a81c5c949$export$54c51a5e259d1ae);
// The input controls both tools share: a drop zone that also takes a click or a
// paste, and the colour swatch picker beside it.
//
// Dropzone.js is already on the page from the header, but it exists to POST
// files somewhere. These tools must not send anything, so they take the files
// straight out of the event instead.
/**
 * Wire a drop zone.
 *
 * @param {object}   options
 * @param {Element}  options.zone      Element that accepts drops and clicks.
 * @param {Element}  options.input     The <input type="file"> behind it.
 * @param {boolean}  options.multiple  Whether more than one file is useful.
 * @param {Function} options.onFiles   Called with an array of image Files.
 * @returns {Function} Removes the paste listener, which is the only one that
 *                     outlives the elements.
 */ function $46e0134a81c5c949$export$a7ad1357dc53be0f({ zone: zone, input: input, multiple: multiple = false, onFiles: onFiles }) {
    const imagesOnly = (files)=>Array.from(files).filter((file)=>file.type.startsWith('image/'));
    // Whatever is left out is said, in a toast: the drop zone is often hidden
    // by then, and a file that silently does nothing reads as a broken tool.
    const tell = (message)=>{
        if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, 'warning');
    };
    const hand = (files)=>{
        const all = Array.from(files);
        const images = imagesOnly(all);
        const skipped = all.length - images.length;
        if (skipped) tell(skipped === 1 && all.length === 1 ? `${all[0].name} is not an image, so there is nothing to do with it here.` : `${skipped} of ${all.length} files are not images and were left out.`);
        if (!images.length) return;
        if (!multiple && images.length > 1) tell(`This tool works on one image at a time, so only ${images[0].name} was opened.`);
        onFiles(multiple ? images : [
            images[0]
        ]);
    };
    zone.addEventListener('click', (event)=>{
        // input.click() dispatches a click that bubbles back here if the input
        // sits inside the zone, and opening the picker from its own click event
        // never stops.
        if (event.target === input) return;
        input.click();
    });
    zone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.click();
        }
    });
    input.addEventListener('change', ()=>{
        hand(input.files);
        // Cleared so that picking the same file twice in a row still fires a
        // change event, which is what someone does after tweaking a setting.
        input.value = '';
    });
    // dragenter and dragleave fire for every child element the pointer crosses,
    // so a counter decides when the pointer has really left rather than the
    // events alone.
    let depth = 0;
    const setDragging = (on)=>zone.classList.toggle('is-dragging', on);
    zone.addEventListener('dragenter', (event)=>{
        event.preventDefault();
        depth += 1;
        setDragging(true);
    });
    zone.addEventListener('dragover', (event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    zone.addEventListener('dragleave', ()=>{
        depth = Math.max(0, depth - 1);
        if (depth === 0) setDragging(false);
    });
    zone.addEventListener('drop', (event)=>{
        event.preventDefault();
        depth = 0;
        setDragging(false);
        hand(event.dataTransfer.files);
    });
    // A screenshot on the clipboard is the shortest path into either tool, so
    // the whole document listens rather than only the focused zone.
    const onPaste = (event)=>{
        const files = Array.from(event.clipboardData?.files || []);
        if (files.length) {
            event.preventDefault();
            hand(files);
        }
    };
    document.addEventListener('paste', onPaste);
    return ()=>document.removeEventListener('paste', onPaste);
}
function $46e0134a81c5c949$export$9587a56f399e19d6() {
    for (const type of [
        'dragover',
        'drop'
    ])window.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest('[data-picker-zone]')) return;
        event.preventDefault();
    });
}
function $46e0134a81c5c949$export$54c51a5e259d1ae() {
    if (typeof window.Coloris === 'undefined') return;
    window.Coloris({
        el: '[data-coloris]',
        theme: 'pill',
        themeMode: 'auto',
        alpha: false,
        swatches: [
            '#ffffff',
            '#e2e8f0',
            '#94a3b8',
            '#334155',
            '#0f172a',
            '#ef4444',
            '#f97316',
            '#f59e0b',
            '#22c55e',
            '#14b8a6',
            '#0ea5e9',
            '#3b82f6',
            '#6366f1',
            '#8b5cf6',
            '#ec4899'
        ]
    });
}

});

parcelRegister("jAuGG", function(module, exports) {

$parcel$export(module.exports, "zip", () => $e4292f061fd6edf9$export$8901015135f2fb22);
// A minimal ZIP writer, so a batch conversion comes back as one file.
//
// Browsers block a page that starts more than a couple of downloads in a row,
// which makes handing over twenty converted images one at a time unworkable.
// A library would do this too, but the archive needed here is the simplest
// shape there is: entries are stored, never deflated, because JPEG, WebP and
// PNG are already compressed and running deflate over them buys nothing.
//
// Format: https://pkware.cachefly.net/webdocs/APPNOTE/APPNOTE-6.3.9.TXT
const $e4292f061fd6edf9$var$LOCAL_HEADER = 0x04034b50;
const $e4292f061fd6edf9$var$CENTRAL_HEADER = 0x02014b50;
const $e4292f061fd6edf9$var$END_OF_DIRECTORY = 0x06054b50;
const $e4292f061fd6edf9$var$STORED = 0;
const $e4292f061fd6edf9$var$crcTable = (()=>{
    const table = new Uint32Array(256);
    for(let n = 0; n < 256; n += 1){
        let c = n;
        for(let k = 0; k < 8; k += 1)c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
        table[n] = c >>> 0;
    }
    return table;
})();
function $e4292f061fd6edf9$var$crc32(bytes) {
    let crc = 0xffffffff;
    for(let i = 0; i < bytes.length; i += 1)crc = $e4292f061fd6edf9$var$crcTable[(crc ^ bytes[i]) & 0xff] ^ crc >>> 8;
    return (crc ^ 0xffffffff) >>> 0;
}
/** The time fields, in the two packed 16-bit words MS-DOS used. */ function $e4292f061fd6edf9$var$dosTime(date) {
    return {
        // Seconds have one bit less than they need, so they count in twos.
        time: date.getHours() << 11 | date.getMinutes() << 5 | date.getSeconds() >> 1,
        // Year is an offset from 1980, which is where the format starts.
        date: Math.max(1980, date.getFullYear()) - 1980 << 9 | date.getMonth() + 1 << 5 | date.getDate()
    };
}
async function $e4292f061fd6edf9$export$8901015135f2fb22(files) {
    const encoder = new TextEncoder();
    const stamp = $e4292f061fd6edf9$var$dosTime(new Date());
    const parts = [];
    const directory = [];
    let offset = 0;
    for (const file of files){
        const name = encoder.encode(file.name);
        const data = new Uint8Array(await file.blob.arrayBuffer());
        const checksum = $e4292f061fd6edf9$var$crc32(data);
        const local = new DataView(new ArrayBuffer(30));
        local.setUint32(0, $e4292f061fd6edf9$var$LOCAL_HEADER, true);
        local.setUint16(4, 20, true); // Version needed: 2.0
        local.setUint16(6, 0x0800, true); // Flags: the name is UTF-8
        local.setUint16(8, $e4292f061fd6edf9$var$STORED, true);
        local.setUint16(10, stamp.time, true);
        local.setUint16(12, stamp.date, true);
        local.setUint32(14, checksum, true);
        local.setUint32(18, data.length, true); // Compressed size
        local.setUint32(22, data.length, true); // Uncompressed size
        local.setUint16(26, name.length, true);
        local.setUint16(28, 0, true); // No extra field
        parts.push(new Uint8Array(local.buffer), name, data);
        const central = new DataView(new ArrayBuffer(46));
        central.setUint32(0, $e4292f061fd6edf9$var$CENTRAL_HEADER, true);
        central.setUint16(4, 20, true); // Version made by
        central.setUint16(6, 20, true); // Version needed
        central.setUint16(8, 0x0800, true);
        central.setUint16(10, $e4292f061fd6edf9$var$STORED, true);
        central.setUint16(12, stamp.time, true);
        central.setUint16(14, stamp.date, true);
        central.setUint32(16, checksum, true);
        central.setUint32(20, data.length, true);
        central.setUint32(24, data.length, true);
        central.setUint16(28, name.length, true);
        central.setUint16(30, 0, true); // Extra field length
        central.setUint16(32, 0, true); // Comment length
        central.setUint16(34, 0, true); // Disk number
        central.setUint16(36, 0, true); // Internal attributes
        central.setUint32(38, 0, true); // External attributes
        central.setUint32(42, offset, true); // Where the local header sits
        directory.push(new Uint8Array(central.buffer), name);
        offset += 30 + name.length + data.length;
    }
    const directorySize = directory.reduce((sum, part)=>sum + part.length, 0);
    const end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, $e4292f061fd6edf9$var$END_OF_DIRECTORY, true);
    end.setUint16(4, 0, true); // This disk
    end.setUint16(6, 0, true); // Disk the directory starts on
    end.setUint16(8, files.length, true);
    end.setUint16(10, files.length, true);
    end.setUint32(12, directorySize, true);
    end.setUint32(16, offset, true);
    end.setUint16(20, 0, true); // Comment length
    return new Blob([
        ...parts,
        ...directory,
        new Uint8Array(end.buffer)
    ], {
        type: 'application/zip'
    });
}

});

parcelRegister("1Euqv", function(module, exports) {

$parcel$export(module.exports, "wireAccountSave", () => $134120eb769dffbc$export$ef5aa585a850b1f);
// The one thing on these pages that leaves the machine.
//
// Everything else here is a promise that nothing is sent anywhere. This is the
// deliberate exception: a signed-in visitor presses a button and the finished
// picture is uploaded to their own account, encrypted like any other upload,
// through /upload/web rather than through anything new. That route already
// knows about plan limits, quotas, folders and the account's upload rules, and
// reusing it means a picture saved from a tool is not a second kind of upload
// with a second set of behaviours to keep in step.
//
// Because it is the exception, the button says what it does, it is never the
// default action, and nothing here runs unless it is pressed.
const $134120eb769dffbc$var$UPLOAD_URL = '/upload/web';
function $134120eb769dffbc$export$e3fbe444a169a808() {
    const node = document.getElementById('toolAccount');
    if (!node || node.dataset.loggedIn !== '1' || !node.dataset.csrf) return null;
    return {
        token: node.dataset.csrf
    };
}
/**
 * Upload one blob and answer with the link.
 *
 * The route replies with JSON on success and, depending on which check refused,
 * either JSON or a bare string on failure, so both shapes are handled rather
 * than assuming the happy one.
 */ async function $134120eb769dffbc$var$upload(blob, filename, token) {
    const form = new FormData();
    form.append('file', blob, filename);
    const response = await fetch($134120eb769dffbc$var$UPLOAD_URL, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': token
        },
        // Same-origin only, and the cookie is what identifies the account.
        credentials: 'same-origin',
        body: form
    });
    const raw = await response.text();
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (err) {
    // A plain-text error, which some of the checks in that route still send.
    }
    if (!response.ok) throw new Error(parsed && parsed.error || raw || `Upload failed (${response.status})`);
    if (!parsed || !parsed.url) throw new Error('The upload finished but did not come back with a link');
    return parsed.url;
}
/** One saved link, with a button that copies it. */ function $134120eb769dffbc$var$linkRow(name, url) {
    const row = document.createElement('li');
    row.className = 'flex items-center gap-3 p-3';
    row.innerHTML = `
        <i class="fa-solid fa-circle-check text-emerald-500 shrink-0"></i>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-xs font-semibold text-slate-900 dark:text-white"></p>
            <a data-link target="_blank" rel="noopener"
               class="block truncate text-xs text-blue-600 hover:underline dark:text-blue-400"></a>
        </div>
        <button type="button" data-copy
            class="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 transition-colors">
            <i class="fa-regular fa-copy"></i>
            <span>Copy</span>
        </button>`;
    row.querySelector('[data-name]').textContent = name;
    const link = row.querySelector('[data-link]');
    link.href = url;
    link.textContent = url;
    const copy = row.querySelector('[data-copy]');
    copy.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(url);
            copy.querySelector('span').textContent = 'Copied';
            setTimeout(()=>{
                copy.querySelector('span').textContent = 'Copy';
            }, 1500);
        } catch (err) {
            // Clipboard access can be refused. The link is on screen and
            // selectable either way, so this is not worth an alert.
            copy.querySelector('span').textContent = 'Press Ctrl+C';
        }
    });
    return row;
}
function $134120eb769dffbc$export$ef5aa585a850b1f({ button: button, panel: panel, list: list, error: error, collect: collect }) {
    if (!button) return false;
    const context = $134120eb769dffbc$export$e3fbe444a169a808();
    if (!context) {
        // No account, so the button would only ever produce a login redirect.
        button.hidden = true;
        return false;
    }
    button.hidden = false;
    button.addEventListener('click', async ()=>{
        const original = button.innerHTML;
        button.disabled = true;
        if (error) error.hidden = true;
        let items = [];
        try {
            items = (await collect()).filter((item)=>item && item.blob);
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = err.message || 'Could not prepare the image';
            }
            button.disabled = false;
            return;
        }
        if (!items.length) {
            button.disabled = false;
            return;
        }
        // Uploaded one at a time rather than all at once: each one is a full
        // request through the encryption and storage path, and a browser that
        // opens ten of those in parallel gets rate limited by our own route.
        let saved = 0;
        try {
            for (const item of items){
                button.innerHTML = items.length > 1 ? `<i class="fa-solid fa-circle-notch fa-spin"></i> Saving ${saved + 1} of ${items.length}` : '<i class="fa-solid fa-circle-notch fa-spin"></i> Saving';
                const url = await $134120eb769dffbc$var$upload(item.blob, item.name, context.token);
                list.prepend($134120eb769dffbc$var$linkRow(item.name, url));
                panel.hidden = false;
                saved += 1;
            }
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = saved ? `${saved} saved, then: ${err.message}` : err.message;
            }
        } finally{
            button.disabled = false;
            button.innerHTML = original;
        }
    });
    return true;
}

});

// The target size compressor on /tools/compress.
//
// The converter next door asks "what quality?" and tells you the size that came
// out. This one is the other way round: you name the size, it finds the quality.
// Same decode, canvas and encode underneath, so both pages agree on what a
// picture is; only the search in tools/target-size.js is new.
//
// Every setting re-runs the list, the way the converter does, so what is on
// screen always matches the controls above it.
// Hitting a file size, rather than picking a quality and hoping.
//
// An encoder takes a quality and answers with a size. This module needs the
// other direction, so it searches: probe a quality, look at the size, halve the
// remaining range, repeat. Six halvings pin a quality down to within one part
// in a hundred, which is finer than anyone can see.
//
// Quality alone is not always enough. A 24 megapixel photo squeezed towards
// 500 kB runs out of quality long before it runs out of pixels, and at that
// point the better trade is fewer pixels rather than worse ones: a half-size
// picture at quality 0.8 beats a full-size one at 0.3 at the same file size,
// and it is not close. So the search spends resolution to buy quality back,
// and the caller is told when it did, because that is a visible change to
// someone's file and it should never happen silently.

var $7JAKl = parcelRequire("7JAKl");
// Nothing is gained above this. The encoders spend a lot of bytes on the last
// few percent and the difference does not show.
const $42719877e500955b$var$MAX_QUALITY = 0.95;
// What the search tries to be able to afford. Once the picture has been made
// smaller, it is made small enough that this quality fits, not merely small
// enough that the bare minimum fits.
const $42719877e500955b$var$AIM_QUALITY = 0.72;
// The lowest quality worth accepting in exchange for keeping every pixel.
//
// Set low on purpose. Changing someone's dimensions is the more surprising of
// the two outcomes, and there is a control on the page for anyone who wants it,
// so the search holds on to the resolution until the quality would be visibly
// bad rather than merely soft. Around 0.4 is where JPEG starts showing its
// blocks; above that, the pixels are worth more.
const $42719877e500955b$var$KEEP_QUALITY = 0.4;
// The absolute floor, used only once the picture is already as small as it is
// allowed to get. At that point anything beats missing the target.
const $42719877e500955b$var$MIN_QUALITY = 0.3;
// Halvings of the quality range. Each one doubles the precision.
const $42719877e500955b$var$QUALITY_PROBES = 6;
// How often the picture may be made smaller before the attempt is given up.
const $42719877e500955b$var$MAX_SCALE_STEPS = 6;
// Below this a result is unrecognisable, and reporting a miss is more useful
// than handing back a thumbnail nobody asked for.
const $42719877e500955b$var$MIN_SCALE = 0.08;
/**
 * The highest quality whose output still fits, on a canvas that is already the
 * right size.
 *
 * `low` and `known` are a quality that fits and its result, so the search
 * always has an answer to fall back on and never returns nothing. `high` is a
 * quality that is known not to fit.
 */ async function $42719877e500955b$var$searchQuality(canvas, mime, targetBytes, low, high, known) {
    let best = {
        blob: known,
        quality: low
    };
    let lo = low;
    let hi = high;
    for(let probe = 0; probe < $42719877e500955b$var$QUALITY_PROBES; probe += 1){
        const quality = (lo + hi) / 2;
        const blob = await (0, $7JAKl.encode)(canvas, mime, quality);
        if (blob.size <= targetBytes) {
            best = {
                blob: blob,
                quality: quality
            };
            lo = quality;
        } else hi = quality;
    }
    return best;
}
async function $42719877e500955b$export$27b5457afe63f538(image, { targetBytes: targetBytes, mime: mime, background: background, maxEdge: maxEdge }) {
    const source = (0, $7JAKl.sizeOf)(image);
    // The cap the visitor asked for is not part of the search. It applies once,
    // up front, and the search works from that size downwards.
    const capped = maxEdge ? (0, $7JAKl.fitWithin)(source.width, source.height, maxEdge, maxEdge) : source;
    let scale = 1;
    let closest = null;
    for(let step = 0; step < $42719877e500955b$var$MAX_SCALE_STEPS; step += 1){
        const atSmallest = scale <= $42719877e500955b$var$MIN_SCALE;
        const width = Math.max(1, Math.round(capped.width * scale));
        const height = Math.max(1, Math.round(capped.height * scale));
        const canvas = (0, $7JAKl.draw)(image, width, height, background);
        const remember = (blob, quality)=>{
            if (!closest || blob.size < closest.blob.size) closest = {
                blob: blob,
                width: width,
                height: height,
                quality: quality,
                scale: scale,
                reached: false
            };
        };
        // The best case. If full quality already fits there is nothing to
        // search for, because no higher quality exists to try.
        const top = await (0, $7JAKl.encode)(canvas, mime, $42719877e500955b$var$MAX_QUALITY);
        if (top.size <= targetBytes) return {
            blob: top,
            width: width,
            height: height,
            quality: $42719877e500955b$var$MAX_QUALITY,
            scale: scale,
            reached: true
        };
        remember(top, $42719877e500955b$var$MAX_QUALITY);
        // The quality worth having. Everything below this is a compromise, so
        // it is also the measurement the next size is estimated from.
        const aim = await (0, $7JAKl.encode)(canvas, mime, $42719877e500955b$var$AIM_QUALITY);
        if (aim.size <= targetBytes) {
            const best = await $42719877e500955b$var$searchQuality(canvas, mime, targetBytes, $42719877e500955b$var$AIM_QUALITY, $42719877e500955b$var$MAX_QUALITY, aim);
            return {
                blob: best.blob,
                width: width,
                height: height,
                quality: best.quality,
                scale: scale,
                reached: true
            };
        }
        remember(aim, $42719877e500955b$var$AIM_QUALITY);
        // Still at the original size: check whether an acceptable quality saves
        // the resolution before giving any of it away.
        if (step === 0) {
            const keep = await (0, $7JAKl.encode)(canvas, mime, $42719877e500955b$var$KEEP_QUALITY);
            if (keep.size <= targetBytes) {
                const best = await $42719877e500955b$var$searchQuality(canvas, mime, targetBytes, $42719877e500955b$var$KEEP_QUALITY, $42719877e500955b$var$AIM_QUALITY, keep);
                return {
                    blob: best.blob,
                    width: width,
                    height: height,
                    quality: best.quality,
                    scale: scale,
                    reached: true
                };
            }
            remember(keep, $42719877e500955b$var$KEEP_QUALITY);
        }
        // As small as it may get, so the quality floor comes off.
        if (atSmallest) {
            const floor = await (0, $7JAKl.encode)(canvas, mime, $42719877e500955b$var$MIN_QUALITY);
            if (floor.size <= targetBytes) {
                const best = await $42719877e500955b$var$searchQuality(canvas, mime, targetBytes, $42719877e500955b$var$MIN_QUALITY, $42719877e500955b$var$AIM_QUALITY, floor);
                return {
                    blob: best.blob,
                    width: width,
                    height: height,
                    quality: best.quality,
                    scale: scale,
                    reached: true
                };
            }
            remember(floor, $42719877e500955b$var$MIN_QUALITY);
            break;
        }
        // File size follows pixel count, so the scale that would have fit is
        // roughly the square root of how far off this one was. A little under
        // that, because the relationship is not exact and overshooting costs a
        // whole extra round. Clamped so a step always makes progress and never
        // skips past the smallest size the search is allowed to try.
        const estimate = scale * Math.sqrt(targetBytes / aim.size) * 0.95;
        scale = Math.max($42719877e500955b$var$MIN_SCALE, Math.min(estimate, scale * 0.9));
    }
    return closest;
}



var $7JAKl = parcelRequire("7JAKl");

var $65gAn = parcelRequire("65gAn");

var $jAuGG = parcelRequire("jAuGG");

var $1Euqv = parcelRequire("1Euqv");
// Long enough that typing "500" does not start a run at "5" and again at "50".
const $b20a011193d6e21f$var$SETTLE_MS = 400;
const $b20a011193d6e21f$var$FORMATS = {
    'image/jpeg': {
        label: 'JPEG',
        extension: 'jpg',
        transparent: false
    },
    'image/webp': {
        label: 'WebP',
        extension: 'webp',
        transparent: true
    }
};
const $b20a011193d6e21f$var$el = (id)=>document.getElementById(id);
const $b20a011193d6e21f$var$dom = {
    zone: $b20a011193d6e21f$var$el('compressZone'),
    input: $b20a011193d6e21f$var$el('compressInput'),
    panel: $b20a011193d6e21f$var$el('compressPanel'),
    target: $b20a011193d6e21f$var$el('compressTarget'),
    unit: $b20a011193d6e21f$var$el('compressUnit'),
    presets: document.querySelectorAll('[data-preset-kb]'),
    format: $b20a011193d6e21f$var$el('compressFormat'),
    formatNote: $b20a011193d6e21f$var$el('compressFormatNote'),
    backgroundRow: $b20a011193d6e21f$var$el('compressBackgroundRow'),
    background: $b20a011193d6e21f$var$el('compressBackground'),
    maxEdge: $b20a011193d6e21f$var$el('compressMaxEdge'),
    list: $b20a011193d6e21f$var$el('compressList'),
    summary: $b20a011193d6e21f$var$el('compressSummary'),
    downloadAll: $b20a011193d6e21f$var$el('compressDownloadAll'),
    clear: $b20a011193d6e21f$var$el('compressClear'),
    saveAccount: $b20a011193d6e21f$var$el('toolSaveAccount'),
    savePanel: $b20a011193d6e21f$var$el('toolSavePanel'),
    saveList: $b20a011193d6e21f$var$el('toolSaveList'),
    saveError: $b20a011193d6e21f$var$el('toolSaveError')
};
const $b20a011193d6e21f$var$items = [];
let $b20a011193d6e21f$var$runToken = 0;
let $b20a011193d6e21f$var$settleTimer = null;
// Which lossy formats this browser will actually produce. Filled in at startup;
// until then the picker offers what the markup lists.
const $b20a011193d6e21f$var$encodable = new Set(Object.keys($b20a011193d6e21f$var$FORMATS));
function $b20a011193d6e21f$var$targetBytes() {
    const amount = Number($b20a011193d6e21f$var$dom.target.value) || 0;
    const unit = $b20a011193d6e21f$var$dom.unit.value === 'MB' ? 1048576 : 1024;
    return Math.max(1024, Math.round(amount * unit));
}
function $b20a011193d6e21f$var$settings() {
    return {
        target: $b20a011193d6e21f$var$targetBytes(),
        format: $b20a011193d6e21f$var$dom.format.value,
        background: $b20a011193d6e21f$var$dom.background.value,
        maxEdge: Number($b20a011193d6e21f$var$dom.maxEdge.value) || 0
    };
}
/**
 * The output type for one image.
 *
 * On automatic, transparency decides: JPEG has no alpha channel, so a cut-out
 * saved as one comes back with a filled rectangle behind it. WebP keeps it, and
 * is the better choice for a photograph too, so it only loses out when this
 * browser cannot write it.
 */ function $b20a011193d6e21f$var$formatFor(item, config) {
    if (config.format !== 'auto') return config.format;
    if (item.transparent && $b20a011193d6e21f$var$encodable.has('image/webp')) return 'image/webp';
    return $b20a011193d6e21f$var$encodable.has('image/jpeg') ? 'image/jpeg' : 'image/webp';
}
function $b20a011193d6e21f$var$syncControls() {
    const forced = $b20a011193d6e21f$var$dom.format.value;
    $b20a011193d6e21f$var$dom.formatNote.textContent = forced === 'auto' ? 'WebP for anything transparent, JPEG for the rest.' : `Every image is written as ${$b20a011193d6e21f$var$FORMATS[forced].label}.`;
    // The colour only matters where transparency has to go somewhere. On
    // automatic that never happens, because transparency picks WebP.
    $b20a011193d6e21f$var$dom.backgroundRow.hidden = forced !== 'image/jpeg';
}
function $b20a011193d6e21f$var$row(item) {
    const node = document.createElement('li');
    node.className = 'flex items-center gap-4 p-4';
    node.innerHTML = `
        <div class="h-14 w-14 shrink-0 rounded-xl overflow-hidden ring-1 ring-slate-200 dark:ring-white/10 bg-slate-100 dark:bg-gray-900/50">
            <img data-thumb alt="" class="h-full w-full object-cover" />
        </div>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-sm font-semibold text-slate-900 dark:text-white"></p>
            <p data-detail class="mt-0.5 text-xs text-slate-500 dark:text-slate-400">Waiting</p>
            <p data-how class="mt-0.5 text-xs text-slate-500 dark:text-slate-400"></p>
        </div>
        <div class="flex items-center gap-2 shrink-0">
            <span data-badge class="hidden rounded-full px-2.5 py-1 text-xs font-semibold"></span>
            <button type="button" data-save disabled
                class="inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <i class="fa-regular fa-arrow-down-to-line"></i>
                <span class="hidden sm:inline">Save</span>
            </button>
            <button type="button" data-remove aria-label="Remove"
                class="inline-flex items-center justify-center h-9 w-9 rounded-xl text-slate-400 hover:text-red-600 hover:bg-red-50 dark:hover:text-red-400 dark:hover:bg-red-900/20 transition-colors">
                <i class="fa-regular fa-xmark"></i>
            </button>
        </div>`;
    node.querySelector('[data-name]').textContent = item.file.name;
    node.querySelector('[data-save]').addEventListener('click', ()=>{
        if (item.output) (0, $7JAKl.saveBlob)(item.output.blob, item.output.name);
    });
    node.querySelector('[data-remove]').addEventListener('click', ()=>$b20a011193d6e21f$var$remove(item));
    item.node = node;
    return node;
}
/** The one line that says what the search actually did. */ function $b20a011193d6e21f$var$describe(output) {
    if (output.passthrough) return 'Already under the target, so the original file is kept unchanged.';
    const parts = [
        `quality ${Math.round(output.quality * 100)}%`
    ];
    if (output.scale < 0.999) parts.push(`scaled to ${Math.round(output.scale * 100)}% (${output.width} x ${output.height})`);
    return parts.join(', ');
}
function $b20a011193d6e21f$var$paint(item) {
    if (!item.node) return;
    const thumb = item.node.querySelector('[data-thumb]');
    const detail = item.node.querySelector('[data-detail]');
    const how = item.node.querySelector('[data-how]');
    const badge = item.node.querySelector('[data-badge]');
    const save = item.node.querySelector('[data-save]');
    if (item.error) {
        detail.textContent = item.error;
        detail.className = 'mt-0.5 text-xs text-red-600 dark:text-red-400';
        how.textContent = '';
        badge.classList.add('hidden');
        save.disabled = true;
        return;
    }
    detail.className = 'mt-0.5 text-xs text-slate-500 dark:text-slate-400';
    if (!item.output) {
        detail.textContent = 'Searching for the right quality';
        how.textContent = '';
        badge.classList.add('hidden');
        save.disabled = true;
        return;
    }
    const { blob: blob, name: name, reached: reached } = item.output;
    thumb.src = item.output.preview;
    detail.textContent = `${(0, $7JAKl.formatBytes)(item.file.size)} to ${(0, $7JAKl.formatBytes)(blob.size)} - ${name}`;
    how.textContent = $b20a011193d6e21f$var$describe(item.output);
    save.disabled = false;
    badge.classList.remove('hidden');
    if (!reached) {
        badge.textContent = 'over target';
        badge.className = 'rounded-full px-2.5 py-1 text-xs font-semibold bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300';
        return;
    }
    const saved = Math.round((1 - blob.size / item.file.size) * 100);
    badge.textContent = saved > 0 ? `-${saved}%` : 'unchanged';
    badge.className = saved > 0 ? 'rounded-full px-2.5 py-1 text-xs font-semibold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300' : 'rounded-full px-2.5 py-1 text-xs font-semibold bg-slate-100 text-slate-600 dark:bg-gray-700 dark:text-slate-300';
}
function $b20a011193d6e21f$var$paintSummary() {
    const done = $b20a011193d6e21f$var$items.filter((item)=>item.output);
    $b20a011193d6e21f$var$dom.downloadAll.disabled = done.length === 0;
    if (!$b20a011193d6e21f$var$items.length) {
        $b20a011193d6e21f$var$dom.summary.textContent = '';
        return;
    }
    const settled = $b20a011193d6e21f$var$items.filter((item)=>item.output || item.error).length;
    if (settled < $b20a011193d6e21f$var$items.length) {
        $b20a011193d6e21f$var$dom.summary.textContent = `Working on ${settled + 1} of ${$b20a011193d6e21f$var$items.length}`;
        return;
    }
    if (!done.length) {
        $b20a011193d6e21f$var$dom.summary.textContent = 'Nothing could be compressed';
        return;
    }
    const before = done.reduce((sum, item)=>sum + item.file.size, 0);
    const after = done.reduce((sum, item)=>sum + item.output.blob.size, 0);
    const saved = before ? Math.round((1 - after / before) * 100) : 0;
    const missed = done.filter((item)=>!item.output.reached).length;
    // A size reached by shrinking the picture is a compromise, and the
    // percentage alone would celebrate it. Said here, not only per row.
    const shrunk = done.filter((item)=>!item.output.passthrough && item.output.scale < 0.999).length;
    const notes = [
        `${done.length} ${done.length === 1 ? 'image' : 'images'}, ${(0, $7JAKl.formatBytes)(before)} to ${(0, $7JAKl.formatBytes)(after)}, ${saved}% smaller`
    ];
    if (shrunk) notes.push(`${shrunk === done.length && shrunk > 1 ? 'All' : shrunk} had to be scaled down to get there`);
    if (missed) notes.push(`${missed} could not reach the target`);
    $b20a011193d6e21f$var$dom.summary.textContent = notes.join('. ') + (notes.length > 1 ? '.' : '');
}
function $b20a011193d6e21f$var$releaseOutput(item) {
    if (item.output) URL.revokeObjectURL(item.output.preview);
    item.output = null;
}
async function $b20a011193d6e21f$var$compressOne(item, config) {
    const mime = $b20a011193d6e21f$var$formatFor(item, config);
    const result = await (0, $42719877e500955b$export$27b5457afe63f538)(item.image, {
        targetBytes: config.target,
        mime: mime,
        // Only ever handed to the encoder that needs it. Filling a colour behind
        // a WebP would destroy the transparency it was chosen to keep.
        background: $b20a011193d6e21f$var$FORMATS[mime].transparent ? null : config.background,
        maxEdge: config.maxEdge
    });
    const source = (0, $7JAKl.sizeOf)(item.image);
    // Re-encoding a file that was already small enough can easily make it
    // bigger, and handing someone a worse copy of a file that never needed
    // touching is the one outcome this tool must not produce.
    if (item.file.size <= config.target && result.blob.size >= item.file.size) return {
        blob: item.file,
        name: item.file.name,
        width: source.width,
        height: source.height,
        quality: 1,
        scale: 1,
        reached: true,
        passthrough: true,
        preview: URL.createObjectURL(item.file)
    };
    return {
        blob: result.blob,
        name: (0, $7JAKl.renameExtension)(item.file.name, $b20a011193d6e21f$var$FORMATS[mime].extension),
        width: result.width,
        height: result.height,
        quality: result.quality,
        scale: result.scale,
        reached: result.reached,
        passthrough: false,
        preview: URL.createObjectURL(result.blob)
    };
}
/**
 * Compress everything with the current settings.
 *
 * One at a time, and each one is nine or so encodes rather than the converter's
 * single pass, so this is the page where doing them in parallel would actually
 * lock the tab up.
 */ async function $b20a011193d6e21f$var$run() {
    const token = $b20a011193d6e21f$var$runToken += 1;
    const config = $b20a011193d6e21f$var$settings();
    for (const item of $b20a011193d6e21f$var$items){
        $b20a011193d6e21f$var$releaseOutput(item);
        if (item.image) item.error = null;
        $b20a011193d6e21f$var$paint(item);
    }
    $b20a011193d6e21f$var$paintSummary();
    for (const item of [
        ...$b20a011193d6e21f$var$items
    ]){
        if (token !== $b20a011193d6e21f$var$runToken) return;
        if (!$b20a011193d6e21f$var$items.includes(item) || !item.image) continue;
        try {
            const output = await $b20a011193d6e21f$var$compressOne(item, config);
            if (token !== $b20a011193d6e21f$var$runToken) {
                URL.revokeObjectURL(output.preview);
                return;
            }
            item.output = output;
            item.error = null;
        } catch (err) {
            item.error = err.message || 'Could not compress this image';
        }
        $b20a011193d6e21f$var$paint(item);
        $b20a011193d6e21f$var$paintSummary();
    }
}
function $b20a011193d6e21f$var$schedule() {
    clearTimeout($b20a011193d6e21f$var$settleTimer);
    $b20a011193d6e21f$var$settleTimer = setTimeout($b20a011193d6e21f$var$run, $b20a011193d6e21f$var$SETTLE_MS);
}
function $b20a011193d6e21f$var$remove(item) {
    const index = $b20a011193d6e21f$var$items.indexOf(item);
    if (index === -1) return;
    $b20a011193d6e21f$var$releaseOutput(item);
    item.node?.remove();
    if (item.image?.close) item.image.close();
    $b20a011193d6e21f$var$items.splice(index, 1);
    $b20a011193d6e21f$var$paintSummary();
    $b20a011193d6e21f$var$togglePanel();
}
function $b20a011193d6e21f$var$togglePanel() {
    $b20a011193d6e21f$var$dom.panel.hidden = $b20a011193d6e21f$var$items.length === 0;
}
async function $b20a011193d6e21f$var$add(files) {
    for (const file of files){
        const item = {
            file: file,
            image: null,
            transparent: false,
            output: null,
            error: null,
            node: null
        };
        try {
            item.image = await (0, $7JAKl.decode)(file);
            item.transparent = (0, $7JAKl.hasAlpha)(item.image);
        } catch (err) {
            item.error = err.message || 'Could not read this image';
        }
        $b20a011193d6e21f$var$items.push(item);
        $b20a011193d6e21f$var$dom.list.appendChild($b20a011193d6e21f$var$row(item));
        $b20a011193d6e21f$var$paint(item);
    }
    $b20a011193d6e21f$var$togglePanel();
    $b20a011193d6e21f$var$run();
}
async function $b20a011193d6e21f$var$downloadAll() {
    const done = $b20a011193d6e21f$var$items.filter((item)=>item.output);
    if (!done.length) return;
    if (done.length === 1) {
        (0, $7JAKl.saveBlob)(done[0].output.blob, done[0].output.name);
        return;
    }
    $b20a011193d6e21f$var$dom.downloadAll.disabled = true;
    try {
        const used = new Map();
        const entries = done.map((item)=>{
            const name = item.output.name;
            const seen = used.get(name) || 0;
            used.set(name, seen + 1);
            return {
                name: seen ? name.replace(/(\.[^.]+)$/, ` (${seen})$1`) : name,
                blob: item.output.blob
            };
        });
        (0, $7JAKl.saveBlob)(await (0, $jAuGG.zip)(entries), 'compressed-images.zip');
    } finally{
        $b20a011193d6e21f$var$dom.downloadAll.disabled = false;
    }
}
/** Drop the formats this browser cannot write, from the set and from the picker. */ async function $b20a011193d6e21f$var$checkEncoders() {
    for (const mime of Object.keys($b20a011193d6e21f$var$FORMATS)){
        if (await (0, $7JAKl.canEncode)(mime)) continue;
        $b20a011193d6e21f$var$encodable.delete(mime);
        $b20a011193d6e21f$var$dom.format.querySelector(`option[value="${mime}"]`)?.remove();
    }
    $b20a011193d6e21f$var$syncControls();
}
function $b20a011193d6e21f$var$markPreset(kb) {
    for (const button of $b20a011193d6e21f$var$dom.presets){
        const active = Number(button.dataset.presetKb) === kb;
        button.setAttribute('aria-pressed', String(active));
    }
}
function $b20a011193d6e21f$var$applyPreset(kb) {
    if (kb >= 1024 && kb % 1024 === 0) {
        $b20a011193d6e21f$var$dom.target.value = String(kb / 1024);
        $b20a011193d6e21f$var$dom.unit.value = 'MB';
    } else {
        $b20a011193d6e21f$var$dom.target.value = String(kb);
        $b20a011193d6e21f$var$dom.unit.value = 'KB';
    }
    $b20a011193d6e21f$var$markPreset(kb);
    $b20a011193d6e21f$var$run();
}
function $b20a011193d6e21f$var$syncPresetFromInput() {
    $b20a011193d6e21f$var$markPreset(Math.round($b20a011193d6e21f$var$targetBytes() / 1024));
}
function $b20a011193d6e21f$var$init() {
    if (!$b20a011193d6e21f$var$dom.zone) return;
    (0, $65gAn.blockStrayDrops)();
    (0, $65gAn.initColourPicker)();
    (0, $65gAn.wirePicker)({
        zone: $b20a011193d6e21f$var$dom.zone,
        input: $b20a011193d6e21f$var$dom.input,
        multiple: true,
        onFiles: $b20a011193d6e21f$var$add
    });
    $b20a011193d6e21f$var$checkEncoders();
    $b20a011193d6e21f$var$syncPresetFromInput();
    for (const button of $b20a011193d6e21f$var$dom.presets)button.addEventListener('click', ()=>$b20a011193d6e21f$var$applyPreset(Number(button.dataset.presetKb)));
    $b20a011193d6e21f$var$dom.target.addEventListener('input', ()=>{
        $b20a011193d6e21f$var$syncPresetFromInput();
        $b20a011193d6e21f$var$schedule();
    });
    $b20a011193d6e21f$var$dom.unit.addEventListener('change', ()=>{
        $b20a011193d6e21f$var$syncPresetFromInput();
        $b20a011193d6e21f$var$run();
    });
    $b20a011193d6e21f$var$dom.format.addEventListener('change', ()=>{
        $b20a011193d6e21f$var$syncControls();
        $b20a011193d6e21f$var$run();
    });
    $b20a011193d6e21f$var$dom.background.addEventListener('input', $b20a011193d6e21f$var$schedule);
    $b20a011193d6e21f$var$dom.maxEdge.addEventListener('input', $b20a011193d6e21f$var$schedule);
    $b20a011193d6e21f$var$dom.downloadAll.addEventListener('click', $b20a011193d6e21f$var$downloadAll);
    (0, $1Euqv.wireAccountSave)({
        button: $b20a011193d6e21f$var$dom.saveAccount,
        panel: $b20a011193d6e21f$var$dom.savePanel,
        list: $b20a011193d6e21f$var$dom.saveList,
        error: $b20a011193d6e21f$var$dom.saveError,
        collect: ()=>$b20a011193d6e21f$var$items.filter((item)=>item.output).map((item)=>({
                    blob: item.output.blob,
                    name: item.output.name
                }))
    });
    $b20a011193d6e21f$var$dom.clear.addEventListener('click', ()=>{
        while($b20a011193d6e21f$var$items.length)$b20a011193d6e21f$var$remove($b20a011193d6e21f$var$items[0]);
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $b20a011193d6e21f$var$init);
else $b20a011193d6e21f$var$init();

})();
//# sourceMappingURL=tools-compress.b6a770ae.js.map
